import { render } from "./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue?vue&type=template&id=34536a03&ts=true"
import script from "./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue?vue&type=script&lang=ts"
export * from "./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__